import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/common";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e2) { setSent(true); } // do not reveal account existence
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-end mb-4"><LanguageSwitcher /></div>
        <Link to="/" className="font-display font-extrabold text-2xl tracking-tight text-primary block text-center mb-8">Deliber<span className="text-secondary">.</span>Act</Link>
        <div className="border border-border bg-white p-8">
          <h1 className="font-display text-2xl font-bold tracking-tight mb-1">{t("Reset your password")}</h1>
          {sent ? (
            <p className="text-sm text-muted-foreground mt-4" data-testid="forgot-sent">{t("If an account exists for")} <strong>{email}</strong>, {t("we've sent a reset link to that email. The link is valid for 1 hour. Please check your inbox.")}</p>
          ) : (
            <>
              <p className="text-sm text-muted-foreground mb-6">{t("Enter your account email and we'll send you a link to choose a new password.")}</p>
              <form onSubmit={submit} className="space-y-4">
                <div><label className="overline block mb-1">{t("Email")}</label><input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={ic} /></div>
                <button data-testid="forgot-submit" disabled={busy} className="w-full bg-primary text-white py-2.5 rounded-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60">{busy ? t("Sending…") : t("Send reset link")}</button>
              </form>
            </>
          )}
          <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary font-semibold">{t("Back to log in")}</Link></p>
        </div>
      </div>
    </div>
  );
}
const ic = "w-full border border-border bg-background rounded-sm px-3 py-2 focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none";
